"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatComposerPastChatsList = ChatComposerPastChatsList;
exports.FIRST_ENABLED_MENU_ITEM = void 0;
exports.pastChatWorkspaceBadge = pastChatWorkspaceBadge;
exports.pastChatsNotice = pastChatsNotice;
var _react = require("react");
var _badge = require("@design/ui/badge");
var _dropdownMenu = require("@design/ui/dropdown-menu");
var _searchInput = require("@design/ui/search-input");
var _truncatedTextWithCursorTooltip = require("../truncated-text-with-cursor-tooltip");
var _useAttachableConversations = require("../../hooks/use-attachable-conversations");
var _useDebouncedValue = require("../../hooks/use-debounced-value");
var _useInfiniteScrollSentinel = require("../../hooks/use-infinite-scroll-sentinel");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FIRST_ENABLED_MENU_ITEM = exports.FIRST_ENABLED_MENU_ITEM = '[role="menuitem"]:not([data-disabled])';
function handleSearchKeyDown(event) {
  var _event$currentTarget$;
  if (event.key === "Escape") return;
  event.stopPropagation();
  if (event.key !== "ArrowDown") return;
  event.preventDefault();
  (_event$currentTarget$ = event.currentTarget.closest('[role="menu"]')) === null || _event$currentTarget$ === void 0 || (_event$currentTarget$ = _event$currentTarget$.querySelector(FIRST_ENABLED_MENU_ITEM)) === null || _event$currentTarget$ === void 0 || _event$currentTarget$.focus();
}
function pastChatsNotice(isLoadingInitial, hasError, pastChatCount) {
  if (hasError) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "px-2 py-1.5 text-sm text-destructive",
    children: "We could not load past chats"
  });
  if (isLoadingInitial || pastChatCount > 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "px-2 py-1.5 text-sm text-muted-foreground",
    "data-sentry-component": "pastChatsNotice",
    "data-sentry-source-file": "chat-composer-past-chats-list.tsx",
    children: "No past chats found"
  });
}
function pastChatWorkspaceBadge(projectName) {
  if (!projectName) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
    className: "ml-auto max-w-[30%]",
    "data-sentry-element": "Badge",
    "data-sentry-component": "pastChatWorkspaceBadge",
    "data-sentry-source-file": "chat-composer-past-chats-list.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_truncatedTextWithCursorTooltip.TruncatedTextWithCursorTooltip, {
      text: projectName,
      "data-sentry-element": "TruncatedTextWithCursorTooltip",
      "data-sentry-source-file": "chat-composer-past-chats-list.tsx"
    })
  });
}
function ChatComposerPastChatsList(_ref) {
  var excludeConversationId = _ref.excludeConversationId,
    attachedConversationIds = _ref.attachedConversationIds,
    onAttachConversation = _ref.onAttachConversation;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var debouncedQuery = (0, _useDebouncedValue.useDebouncedValue)(query, _useDebouncedValue.SEARCH_DEBOUNCE_MS);
  var _useAttachableConvers = (0, _useAttachableConversations.useAttachableConversations)(debouncedQuery),
    items = _useAttachableConvers.items,
    isLoadingInitial = _useAttachableConvers.isLoadingInitial,
    isLoadingMore = _useAttachableConvers.isLoadingMore,
    hasMore = _useAttachableConvers.hasMore,
    hasError = _useAttachableConvers.hasError,
    loadMore = _useAttachableConvers.loadMore;
  var sentinelRef = (0, _useInfiniteScrollSentinel.useInfiniteScrollSentinel)({
    hasMore: hasMore,
    isLoadingMore: isLoadingMore,
    loadMore: loadMore
  });
  var pastChats = items.filter(function (conversation) {
    return conversation.id !== excludeConversationId;
  });
  function renderPastChat(conversation) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
      "data-testid": "chat-composer-past-chat",
      disabled: attachedConversationIds.includes(conversation.id),
      onSelect: function onSelect() {
        return onAttachConversation({
          id: conversation.id,
          name: conversation.name
        });
      },
      "data-sentry-element": "DropdownMenuItem",
      "data-sentry-component": "renderPastChat",
      "data-sentry-source-file": "chat-composer-past-chats-list.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_truncatedTextWithCursorTooltip.TruncatedTextWithCursorTooltip, {
        text: conversation.name,
        "data-sentry-element": "TruncatedTextWithCursorTooltip",
        "data-sentry-source-file": "chat-composer-past-chats-list.tsx"
      }), pastChatWorkspaceBadge(conversation.projectName)]
    }, conversation.id);
  }
  var notice = pastChatsNotice(isLoadingInitial, hasError, pastChats.length);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchInput.SearchInput, {
      autoFocus: true,
      className: "mb-1",
      placeholder: "Search past chats\u2026",
      "aria-label": "Search past chats",
      value: query,
      onValueChange: setQuery,
      onKeyDown: handleSearchKeyDown,
      "data-sentry-element": "SearchInput",
      "data-sentry-source-file": "chat-composer-past-chats-list.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "max-h-[420px] overflow-y-auto",
      children: [pastChats.map(renderPastChat), notice, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: sentinelRef
      })]
    })]
  });
}